/**
 * Step1BasicInfo Component
 * Step 1: 기본 정보 입력 (Title, Description)
 *
 * 입력 정책(#282): 길이 상한 + 글자수 카운터.
 */

import React from 'react';
import { Box, TextField } from '@mui/material';
import { PROJECT_TITLE_MAX, PROJECT_DESCRIPTION_MAX } from '@/domain/namePolicy';
import type { WizardFormData } from './types';

interface Step1BasicInfoProps {
  data: WizardFormData;
  onChange: (data: Partial<WizardFormData>) => void;
}

const counter = (value: string, max: number) => `${value.length}/${max}`;

const Step1BasicInfo: React.FC<Step1BasicInfoProps> = ({ data, onChange }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      width: '100%',
      maxWidth: 600,
      mx: 'auto',
      my: 'auto', // 고정 틀 안에서 세로 중앙 — 짧은 단계가 위에 붙어 빈 벽을 남기지 않게
      py: 2,
    }}
  >
    {/* Title */}
    <TextField
      label="Title"
      value={data.title}
      onChange={(e) => onChange({ title: e.target.value.slice(0, PROJECT_TITLE_MAX) })}
      fullWidth
      required
      placeholder="프로젝트 이름을 입력하세요"
      autoFocus
      inputProps={{ maxLength: PROJECT_TITLE_MAX }}
      helperText={counter(data.title, PROJECT_TITLE_MAX)}
    />

    {/* Description */}
    <TextField
      label="Description"
      value={data.description}
      onChange={(e) =>
        onChange({ description: e.target.value.slice(0, PROJECT_DESCRIPTION_MAX) })
      }
      fullWidth
      multiline
      rows={3}
      placeholder="프로젝트 설명을 입력하세요 (선택)"
      inputProps={{ maxLength: PROJECT_DESCRIPTION_MAX }}
      helperText={counter(data.description, PROJECT_DESCRIPTION_MAX)}
    />
  </Box>
);

export default Step1BasicInfo;
